import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {HOSTNAME} from "../../Configs/Domain";


// Async thunk for fetching sectors and industries
export const fetchSectorsIndustries = createAsyncThunk(
  'catalog/fetchSectorsIndustries',
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(`${HOSTNAME}/tickers/categories/list`);
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      console.log("Data from fetchSectorsIndustries:", data);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const blacklistCatalogSlice = createSlice({
  name: 'catalog',
  initialState: {
    sectors: [],
    industries: [],
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {
    // Potential reducers for catalog management (if needed)
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSectorsIndustries.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchSectorsIndustries.fulfilled, (state, action) => {
        state.status = 'succeeded';
        // Assuming the payload structure matches your needs
        state.sectors = action.payload.sector;
        state.industries = action.payload.industry;
      })
      .addCase(fetchSectorsIndustries.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });

  },
});
export default blacklistCatalogSlice.reducer;
